import React from 'react'

const Quotations = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Quotations</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Sales</li>
            <li className="breadcrumb-item active">Quotations</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Quotations</h5>
                <p>Quotations content will be displayed here.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Quotations

